import React from 'react';
interface PalmLinesProps {
  className?: string;
  flip?: boolean;
}

/** Subtle champagne-gold palm-leaf line illustration. Decorative only. */
export function PalmLines({
  className = '',
  flip = false
}: PalmLinesProps) {
  return <svg viewBox="0 0 240 320" aria-hidden="true" focusable="false" className={className} style={{
    transform: flip ? 'scaleX(-1)' : undefined
  }} data-id="element-409" data-mp="7hp95tibepef">
      <g fill="none" stroke="#C89B43" strokeWidth="1" strokeLinecap="round" opacity="0.5" data-id="element-410" data-mp="3ulwo87315368">
        <path d="M120 316V96" data-id="element-411" data-mp="3ek8lwhsoxsf" />
        <path d="M120 150c-26-14-48-46-52-84 30 6 54 30 64 60" data-id="element-412" data-mp="3kp0i280lst4u" />
        <path d="M120 150c26-14 48-46 52-84-30 6-54 30-64 60" data-id="element-413" data-mp="3kqv3rojp8p9z" />
        <path d="M120 196c-30-10-58-38-68-74 34 2 62 24 76 54" data-id="element-414" data-mp="3pomsk9p1rv9y" />
        <path d="M120 196c30-10 58-38 68-74-34 2-62 24-76 54" data-id="element-415" data-mp="1ixnebmadgrad" />
        <path d="M120 108c-14-22-16-52-6-78 16 20 22 50 14 76" data-id="element-416" data-mp="1ivax5bcfukyd" />
        <path d="M120 108c14-22 16-52 6-78-16 20-22 50-14 76" data-id="element-417" data-mp="1nvffl6wwppr8" />
      </g>
    </svg>;
}